var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticClass:"cus-table fs-14",attrs:{"bordered":"","data-source":_vm.dataSource,"columns":_vm.columns,"pagination":false,"rowKey":"name1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }